import {
  FETCH_SUMMARY_TRUCK_INIT,
  FETCH_SUMMARY_TRUCK_SUCCESS,
  FETCH_SUMMARY_TRUCK_FAILURE,
  FETCH_SUMMARY_TRUCK_COUNT_INIT,
  FETCH_SUMMARY_TRUCK_COUNT_SUCCESS,
  FETCH_SUMMARY_TRUCK_COUNT_FAILURE,
  FETCH_SUMMARY_TRUCK_NO_LOADING_SUCCESS,
  FETCH_SUMMARY_TRUCK_NO_LOADING_FAILURE,
  FETCH_SUMMARY_TRUCK_NO_LOADING_INIT,
  SET_FILTER_SUMMARY_TRUCK,
  RESET_SUMMARY_TRUCK
} from './types';
import API from './api';

/* Actions Creators */

export function setFilterSummaryTruck(obj) {
  return {
    type: SET_FILTER_SUMMARY_TRUCK,
    payload: obj
  };
}

export function resetSummaryTruck() {
  return {
    type: RESET_SUMMARY_TRUCK
  };
}

/* Fetch summary */

function fetchApiSuccess(data) {
  return {
    type: FETCH_SUMMARY_TRUCK_SUCCESS,
    payload: data
  };
}

function fetchApiFailure(error) {
  return {
    type: FETCH_SUMMARY_TRUCK_FAILURE,
    payload: error
  };
}

function fetchApiInit() {
  return {
    type: FETCH_SUMMARY_TRUCK_INIT
  };
}

export function fetchSummaryTruckApi(group, tags) {
  return async dispatch => {
    dispatch(fetchApiInit());
    try {
      let data = await API.data.getAll(group, tags);
      dispatch(fetchApiSuccess(data));
    } catch (error) {
      dispatch(fetchApiFailure(error));
    }
  };
}

/*  No loading */

function fetchApiNoLoadingSuccess(data, concat) {
  return {
    type: FETCH_SUMMARY_TRUCK_NO_LOADING_SUCCESS,
    payload: data,
    concat
  };
}

function fetchApiNoLoadingFailure(error) {
  return {
    type: FETCH_SUMMARY_TRUCK_NO_LOADING_FAILURE,
    payload: error
  };
}

function fetchApiNoLoadingInit() {
  return {
    type: FETCH_SUMMARY_TRUCK_NO_LOADING_INIT
  };
}

export function fetchSummaryTruckNoLoadingApi(obj) {
  return async dispatch => {
    dispatch(fetchApiNoLoadingInit());
    try {
      let data = await API.data.getAll(obj);
      dispatch(fetchApiNoLoadingSuccess(data, obj.concat));
    } catch (error) {
      dispatch(fetchApiNoLoadingFailure(error));
    }
  };
}

/* COUNT */

function fetchApiCountSuccess(data) {
  return {
    type: FETCH_SUMMARY_TRUCK_COUNT_SUCCESS,
    payload: data
  };
}

function fetchApiCountFailure(error) {
  return {
    type: FETCH_SUMMARY_TRUCK_COUNT_FAILURE,
    payload: error
  };
}

function fetchApiCountInit() {
  return {
    type: FETCH_SUMMARY_TRUCK_COUNT_INIT
  };
}

export function fetchSummaryTruckCountApi(obj) {
  return async dispatch => {
    dispatch(fetchApiCountInit());
    try {
      let data = await API.data.getCount(obj);
      dispatch(fetchApiCountSuccess(data));
    } catch (error) {
      dispatch(fetchApiCountFailure(error));
    }
  };
}



// WEBPACK FOOTER //
// ./source/client/actions/summary_truck/index.js